import installer from './defaults'
export * from '@vuesax-plus/components'
export * from '@vuesax-plus/constants'
export * from '@vuesax-plus/directives'
export * from '@vuesax-plus/hooks'
export * from '@vuesax-plus/locale'
export * from '@vuesax-plus/tokens'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer
